import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { t } from 'i18next';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { TextFormField } from '~components/FormFields/TextFormField';
import useLogin from '~hooks/useLogin/useLogin';
import Copyright from '~pages/Auth/Copyrigh';
import FormWrapperBox from '~pages/Auth/FormWrapperBox';
import LinkToSignIn from '~pages/Auth/LinkToSignIn';
import PageWrapWithBackGround from '~pages/Auth/PageWrapWithBackGround';
import { FormInputProps, inputTypes } from '~pages/Auth/types';
import { forgotPasswordValidationSchema } from '~pages/Auth/validationSchemas';

import TermsAndConditions from './TermsAndConditions';

const formInputs: FormInputProps[] = [
  {
    name: inputTypes.email,
    label: 'Email',
    type: inputTypes.email,
    id: inputTypes.email,
  },
];

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { triggerResetPassword } = useLogin();

  const onSubmit = async (data: { email: string }) => {
    setIsLoading(true);
    try {
      await triggerResetPassword({ email: data.email });
    } catch {
      // Errors are handled in useLogin.
    } finally {
      setIsLoading(false);
    }
  };

  const {
    handleSubmit,
    control,
    formState: { errors, isDirty },
  } = useForm<{ email: string }>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(forgotPasswordValidationSchema),
    defaultValues: {
      email: '',
    },
  });

  return (
    <PageWrapWithBackGround>
      <FormWrapperBox title={t('page_headings.forgot_password')}>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {formInputs.map((input, index) => (
            <TextFormField
              key={`${input.name}-${index}`}
              control={control}
              errors={errors}
              name={input.name}
              label={input.label}
              id={input.id}
              inputProps={{ 'data-test-id': input.id }}
            />
          ))}
          <Button
            fullWidth
            disabled={!isDirty}
            loading={isLoading}
            size={'small'}
            data-test-id={'submit-button'}
            variant={'contained'}
            color={'primary'}
            sx={{ mt: 1 }}
            type={'submit'}
          >
            {t('actions.sendResetEmail')}
          </Button>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: 4,
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
              }}
            >
              <LinkToSignIn />
            </Box>
          </Box>
        </Box>
        <TermsAndConditions sx={{ mt: 3 }} />
        <Copyright sx={{ mt: 2, mb: 4 }} />
      </FormWrapperBox>
    </PageWrapWithBackGround>
  );
};
export default ForgotPassword;
